import {
  getDisciplineIcon,
  getDisciplineName,
} from '../../../../utils/discipline';
import { Chip } from '../../../atoms/Chip';
import { Icon } from '../../../atoms/Icon';
import { Typography } from '../../../molecules/Typography';
import { useScheduleSlotContext } from '../useScheduleSlotContext';

interface IScheduleSlotHeaderProps {
  type: 'discipline' | 'simulated' | 'essay';
  title?: string;
  progressText?: string;
  finished?: boolean;
}

export function ScheduleSlotHeader({
  type,
  title,
  progressText,
  finished,
}: IScheduleSlotHeaderProps) {
  const { selected, disciplineSlug, type: slotType } = useScheduleSlotContext();

  const disciplineIcon = getDisciplineIcon(disciplineSlug);
  const disciplineName = getDisciplineName(disciplineSlug);

  if (type === 'discipline' || type === 'essay') {
    return (
      <div className={'flex items-center gap-2'}>
        <Icon
          type={'svg'}
          Icon={disciplineIcon}
          className={`w-6 text-disciplina-${disciplineSlug} ${selected ? 'text-mono-color-white' : ''}`}
        />
        <Typography
          size={slotType === 'summary' ? 'default' : 'small'}
          className={` ${selected ? 'text-mono-color-white' : ''}`}
        >
          {disciplineName}
        </Typography>
        {slotType === 'summary' &&
          (finished && type !== 'essay' ? (
            <Chip
              size={'sm'}
              className={'border-none bg-feedback-color-success-pure ml-auto'}
            >
              Concluído
            </Chip>
          ) : (
            <Typography size={'mini'} className='ml-auto'>
              {progressText}
            </Typography>
          ))}
      </div>
    );
  }

  if (type === 'simulated') {
    return (
      <div className={'flex items-center justify-between gap-2'}>
        <Typography size={'small'} className={`text-card-color-negative`}>
          {title}
        </Typography>
        <Chip size='sm' variant='negative'>
          Simulado
        </Chip>
      </div>
    );
  }

  return <div>Header</div>;
}
